import { Box, Typography } from '@mui/material';
import React from 'react';

import type {
  CellRendererErrorBoundaryProps,
  CellRendererErrorBoundaryState
} from './CellRendererErrorBoundary.types';

/**
 * Error boundary wrapper for AG Grid cell renderers
 * Catches and displays errors gracefully without breaking the entire grid
 */
export default class CellRendererErrorBoundary extends React.Component<
  CellRendererErrorBoundaryProps,
  CellRendererErrorBoundaryState
> {
  constructor(props: CellRendererErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Cell renderer error:', error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children, fallback } = this.props;

    if (hasError) {
      return (
        fallback || (
          <Box sx={{ color: 'error.main', fontSize: '0.75rem' }}>
            <Typography variant="caption">Error rendering cell</Typography>
          </Box>
        )
      );
    }

    return children;
  }
}
